import { render, staticRenderFns } from "./Direto.vue?vue&type=template&id=139fe387&scoped=true"
import script from "./Direto.vue?vue&type=script&lang=js"
export * from "./Direto.vue?vue&type=script&lang=js"
import style0 from "./Direto.vue?vue&type=style&index=0&id=139fe387&prod&lang=css"
import style1 from "./Direto.vue?vue&type=style&index=1&id=139fe387&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139fe387",
  null
  
)

export default component.exports